import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ICompany } from '../../../../core/models/ICompany';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Filters } from '../../filters/filters';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CompanyCard } from '../company-card/company-card';
import { CompanyService } from '../../../../core/services/company.service';

@Component({
  selector: 'app-company-list',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule, 
    Filters, 
    MatPaginatorModule,
    CompanyCard
  ],
  templateUrl: './company-list.html',
  styleUrl: './company-list.scss'
})
export class CompanyList implements OnInit, OnChanges {

  @Input() favoriteMode = false;
  @Input() searchMode = false;
  @Input() searchResults: any = {};
  @Input() searchTerm: string = ''; // ← AJOUTÉ pour le terme de recherche
  
  pagedCompanies: ICompany[] = [];
  totalCompanies = 0;
  pageIndex = 0;
  pageSize = 8;
  currentFilters: any = {};

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  
  constructor(
    private paginatorIntl: MatPaginatorIntl, 
    private companyService: CompanyService
  ){
    this.paginatorIntl.itemsPerPageLabel = 'Sociétés par page:';
  }

  ngOnInit(): void {
    if (!this.searchMode) {
      this.loadCompanies();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchResults'] && this.searchMode) {
      this.pagedCompanies = this.searchResults.data || [];
      this.totalCompanies = this.searchResults.total || 0;
    }
  }

  onFiltersChanged(filters: any) {
    this.currentFilters = { ...filters };
    this.pageIndex = 0;
    this.loadCompanies();
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadCompanies();
  }

  loadCompanies() {
    const params: any = {
      page: this.pageIndex + 1,
      limit: this.pageSize,
      category: this.currentFilters.category,
      city: this.currentFilters.city,
      country: this.currentFilters.country,
      minRating: this.currentFilters.minRating,
      sortBy: this.currentFilters.sortBy,
      order: this.currentFilters.order
    };

    if (this.searchMode && this.searchTerm) {
      params.search = this.searchTerm;
    }

    if (
      this.currentFilters.nearMe &&
      this.currentFilters.latitude &&
      this.currentFilters.longitude
    ) {
      params.nearMe = true;
      params.radiusKm = this.currentFilters.radiusKm;
      params.lat = this.currentFilters.latitude;
      params.lng = this.currentFilters.longitude;
    }

    if (this.favoriteMode) {
      this.companyService.getFavoriteCompanies(params).subscribe(res => {
        this.pagedCompanies = res.data;
        this.totalCompanies = res.total;
      });
    } else {
      this.companyService.getCompaniesByFilters(params).subscribe(res => {
        this.pagedCompanies = res.data;
        this.totalCompanies = res.total;
      });
    }
  }
}